import Dropdown from "@/components/dropdownLegacy/DropdownLegacy";
import { SITEMAP_MOBILE_MENU_OPTIONS } from "@/constants/sitemap";
import styles from "./sitemap.module.scss";

export default function NavContainer({
  mobileOption,
  mobileSelect,
}: {
  mobileOption: string;
  mobileSelect: (value: string) => void;
}) {
  return (
    <div className={styles.upperContainer}>
      <h1 className={styles.heading}>Site Map</h1>
      <div className={styles.dropdown}>
        <Dropdown
          value={mobileOption}
          setValue={mobileSelect}
          options={SITEMAP_MOBILE_MENU_OPTIONS}
          label="VIEW"
          aria-label="Select a time range"
        />
      </div>
    </div>
  );
}
